<template>
  <div class="cursor_pointer" @click="toggleListening()">
    <div class="pulse-container" :class="{ 'pulse': isListening }">
      <MicrophoneIcon />
    </div>
  </div>
</template>

<script>
import MicrophoneIcon from '../../ChatIcons/MicrophoneIcon.vue';

export default {
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isListening: false,
      finalTranscript: '',
      silenceTimer: null,
      recognition: null
    };
  },
  mounted() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert('Speech recognition not supported in this browser.');
      return;
    }

    this.recognition = new SpeechRecognition();
    this.recognition.continuous = true;
    this.recognition.interimResults = true;
    this.recognition.lang = 'en-US';
    this.recognition.maxAlternatives = 1;

    this.recognition.onresult = this.onResult;
    this.recognition.onend = this.onEnd;
    this.recognition.onerror = this.onError;
  },
  methods: {
    toggleListening() {
      if (!this.isListening) {
        this.finalTranscript = '';
        this.recognition.start();
        this.isListening = true;
        console.log('Listening...');
      } else {
        this.recognition.stop();
        this.isListening = false;
        clearTimeout(this.silenceTimer);
        console.log('Stopped manually.');
      }
    },
    onResult(event) {
      let interimTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        const transcript = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          this.finalTranscript += transcript + ' ';
        } else {
          interimTranscript += transcript;
        }
      }

      // this.emitMessage(this.finalTranscript + interimTranscript);
      this.$emit('voiceMessageText', this.finalTranscript + interimTranscript)

      clearTimeout(this.silenceTimer);
      this.silenceTimer = setTimeout(() => {
        this.recognition.stop();
        this.isListening = false;
        console.log(`Final transcript:\n${this.finalTranscript.trim()}`);
        this.$emit('voiceMessage', this.finalTranscript.trim())
      }, 3000);
    },
    onEnd() {
      if (this.isListening) {
        this.isListening = false;
        console.log(`Final transcript:\n${this.finalTranscript.trim()}`);
      }
    },
    onError(event) {
      console.error('Speech recognition error:', event.error);
      this.isListening = false;
      clearTimeout(this.silenceTimer);
      console.log(`Error occurred: ${event.error}`);
    }
  },
  components: {
    MicrophoneIcon
  }
};
</script>

<style scoped>
.pulse-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pulse {
  animation: pulse-animation 2s infinite;
  background-color: #f6f6f6;
}



@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }

  100% {
    box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
  }
}
</style>
